import CDNAssetMixin from "@/mixins/CDNAssetMixin";
import AppConfigMixin from "@/mixins/AppConfigMixin";
import GlobalDatesMixin from "@/mixins/GlobalDatesMixin";

const InstallMixins = (app) => {
  app.mixin(CDNAssetMixin);
  app.mixin(AppConfigMixin);
  app.mixin(GlobalDatesMixin);
};

export default InstallMixins;
